'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitConfirmPassword = exports.getUiConfirmPassword = exports.CONFIRM_PASSWORD_SUCCESS = exports.CONFIRM_PASSWORD_REQUEST = exports.CONFIRM_PASSWORD_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('./user');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CONFIRM_PASSWORD_FAIL = exports.CONFIRM_PASSWORD_FAIL = 'la/ui/confirmPassword/FAIL';
var CONFIRM_PASSWORD_REQUEST = exports.CONFIRM_PASSWORD_REQUEST = 'la/ui/confirmPassword/REQUEST';
var CONFIRM_PASSWORD_SUCCESS = exports.CONFIRM_PASSWORD_SUCCESS = 'la/ui/confirmPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CONFIRM_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case CONFIRM_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case CONFIRM_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.confirmPassword;
};

var getUiConfirmPassword = exports.getUiConfirmPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitConfirmPassword = exports.submitConfirmPassword = function submitConfirmPassword(password) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, username, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                type: CONFIRM_PASSWORD_REQUEST
                            });
                            state = getState();
                            username = (0, _user.getBidderEmail)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.next = 7;
                            return _api.Auth.postConfirmPassword({ deployment: deployment, password: password, username: username });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: CONFIRM_PASSWORD_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0.message === 'Failed to get the login.') {
                                dispatch({
                                    error: true,
                                    payload: { message: 'Invalid password' },
                                    type: CONFIRM_PASSWORD_FAIL
                                });
                            } else {
                                dispatch({
                                    error: true,
                                    payload: _context.t0,
                                    type: CONFIRM_PASSWORD_FAIL
                                });
                            }

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/confirmPassword.js
// module id = pOp2
// module chunks = 60